"use client";
import { Fragment, useCallback, useEffect, useRef, useState } from "react";
import { Check, Edit3, Signature } from "lucide-react";
import { Numeral } from "../../../../components/numeral/Numeral";
import { EmailOutlined } from "@mui/icons-material";

import { ReactComponent as GalileIcon } from "../../../../public/logos/galilea-icono.svg";
import { BottomSheet } from "../../../../components/new_components/BottomSheet";
import { FechasRadioGroup } from "../../../../components/new_components/fechasRadioGroup";
import { ReactComponent as ArrowRight } from "../../../../public/svg/ArrowRight2.svg";
import { ReactComponent as FilesIcon } from "./../../../../public/svg/Files.svg";
import { ContractV3 } from "../../../../components/new_components/Agreements/ContractV3";
import { PromissoryV2 } from "../../../../components/new_components/Agreements/PromissoryV2";
import AnimationComponent from "../../../../components/new_components/animation";
import { ManualSignV3 } from "../../../../components/new_components/Agreements/ManualSignV3";
import { creditOfferStore } from "../../../../store/creditStore/offerCreditStore";
import { APIClient } from "../../../../helpers/api_helper";
import {
  GET_AVAILABLE_REWARD,
  REQUEST_PROCESS_PHYSICAL_SIGNATURE,
} from "../../../../helpers/url_helper";
import { calcDescuentoFirmaElectronicaV1 } from "../../../../utils/creditUser/calcDctoFirmaElectronica";
import {
  convertToNumber,
  isValidNumber,
} from "../../../../utils/isValidNumber";
import {
  calcInteresCorrienteV2,
  calcularInteresCorrienteTed,
  calcularInteresCorrienteTem,
} from "../../../../utils/creditUser/calcInteresCorriente";
import { variablesGlobales } from "../../../../configs/variables";
import {
  getAndSetInterestTea,
  getInterest,
} from "../../../../utils/creditUser/getInterest";
import { CreditsService } from "../../../../services/credits/credits.service";
import moment from "moment/moment";

import { InfoAlert } from "../../../../components/alerts/infoAlert";
import { ErrorAlert } from "../../../../components/alerts/errorAlert";
import { validateCreditDatesFromViewOffer } from "../../helpers/helper";
import axios from "axios";
import { useAlert } from "./../bankFlowSelector/provider/alertProvider";
import {
  NextButton,
  PrevButton,
} from "../../../../components/new_components/buttonsFlow";
import { useCreditStore } from "../../../../store/creditStore/creditUserStore";
import AmountSlider from "../../../../components/new_components/AmountSlider";
import { validateSessionAndJwtToken } from "../../../../utils/validateTokenSession";
import { HttpRequest } from "../../../../services/httpRequest";
import { returnToSignin } from "../../../../utils/returnToSign";
import { useNavigate } from "react-router-dom";
import { montoElegido, rangoMonto, trackEvent, trackEventOnce } from "../../../../services/analytics/track";

const apiClient = new APIClient();
const api = new APIClient();

const RenovarDatosOfertaForm = ({
  onStepChange,
  stepTitlesGeneral,
  currentStepGeneral,
  isDesktop,
  currentStep: parentStep,
}) => {
  const { showAlert } = useAlert();
  const { offerCreditStore, saveOfertCredit, loadOfertCredit } =
    creditOfferStore();
  const { creditUserStore, loadUser } = useCreditStore();
  const navigate = useNavigate();

  const [vencimientoEnDias, setVencimientoEnDias] = useState(0);
  const [messsageAlert] = useState("");
  const [isOpenError] = useState(false);
  const [alertSession] = useState(false);
  const [isOpenInfo] = useState(false);

  const [currentStep, setCurrentStep] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [isApprovedCridit, setIsApprovedCridit] = useState(false);
  const [viewAprobate, setViewAprobate] = useState(0);
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [openSheetFechas, setOpenSheetFechas] = useState(false);
  const [openSheetRangoQupo, setOpenSheetRangoQupo] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [titleDialog, setTitleDialog] = useState(false);
  const [descriptionDialog, setDescriptionDialog] = useState(false);
  const [isSelectedTipoFirma, setIsSelectedTipoFirma] = useState("electronica");
  const [openSheetFirma, setOpenSheetFirma] = useState(false);
  const [dialogOpenContrato, setDialogOpenContrato] = useState(false);
  const [fechaSelected, setFechaSelected] = useState();
  const [activeTab, setActiveTab] = useState("contrato");

  const [dialogOpenContratoFirma, setDialogOpenContratoFirma] = useState(false);
  const [, setDiscountForReward] = useState(null);
  const [checkFirmaElectronica, setCheckFirmaElectronica] = useState(true);
  const [interest, setInterest] = useState(0);

  const [total, setTotal] = useState(0);
  const [firmaElectronicaValue, setFirmaElectronicaValue] = useState(0);
  const [dctoFirmaElectronica, setDctoFirmaElectronica] = useState(0);
  const [isDesktopReize] = useState(false);
  const [tasaUsuraTmlvRate, setTasaUsuraTmlvRate] = useState("");
  const [limitFirmaFisica, setLimitFirmaFisica] = useState(0);

  // Snapshots sin volverlos dependencia reactiva de calculateInterest/calcFirmaElectronica/
  // calcDiscountForReward: esos estados los escribe el MISMO efecto que los calcula, así
  // que depender de ellos reactivamente reintroduciría el ciclo documentado más abajo.
  const tasaUsuraTmlvRateRef = useRef(tasaUsuraTmlvRate);
  useEffect(() => {
    tasaUsuraTmlvRateRef.current = tasaUsuraTmlvRate;
  });
  const firmaElectronicaValueRef = useRef(firmaElectronicaValue);
  useEffect(() => {
    firmaElectronicaValueRef.current = firmaElectronicaValue;
  });

  const [isTransitioning, setIsTransitioning] = useState(false);
  const [selectedQuota, setSelectedQuota] = useState(0);
  // const [approvedQuota, setApprovedQuota] = useState(0);
  const [rewardHistoryAvailable, setRewardHistoryAvailable] = useState();
  const [cupoDisponible, setCupoDisponible] = useState("");

  const [formDataOferta, setFormDataOferta] = useState({
    approvedQuota: 200000,
    selectedQuota: 0,
    paydayLimit: "",
    aceptaTerminos: false,
    termInDays: 0,
    tipoFirma: "",
    total: "",
    numeroBanco: 0,
    tipoCuenta: "",
  });

  const [errors, setErrors] = useState({});
  const starsRef = useRef(null);

  const hasValidatedRef = useRef(false);

  const stepTitles = ["Oferta de crédito"];

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const totalSteps = stepTitles.length;

  const changeTipoFirma = (value) => {
    setIsSelectedTipoFirma(value);
  };

  const handleToggleDialog = () => {
    if (openSheetFechas) {
      setOpenSheetFechas(false);
    } else {
      setOpenSheetFechas(true);
    }
  };

  const handleToggleDialogCupo = () => {
    if (openSheetRangoQupo) {
      setOpenSheetRangoQupo(false);
    } else {
      setOpenSheetRangoQupo(true);
    }
  };

  const handleToggleDialogFirma = () => {
    if (openSheetFirma) {
      setOpenSheetFirma(false);
    } else {
      setOpenSheetFirma(true);
    }
  };

  const handleToggleDialogContratos = () => {
    if (dialogOpenContrato) {
      setDialogOpenContrato(false);
    } else {
      setDialogOpenContrato(true);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormDataOferta((prev) => ({ ...prev, [name]: value }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
    if (name === "tipoFirma") {
      if (value === "fisica") {
        setDialogOpenContratoFirma(true);
        setCheckFirmaElectronica(false);
      } else {
        setCheckFirmaElectronica(true);
      }
    }
  };

  const handleAccept = () => {
    setOpenDialog(!openDialog);
  };

  const validateTokenization = useCallback(async () => {
    const documento = localStorage.getItem("doc");
    try {
      const tokenSession = localStorage.getItem("token_jwt");

      const res = await axios.post(
        `${variablesGlobales.urlServiceBackend}/api/v1/tokenization/validate-tokenization`,
        {
          doc: documento,
        },
        {
          headers: {
            authorization: `Bearer ${tokenSession}`,
            "X-API-KEY-GALILEA": variablesGlobales.x_api_key_wompi_checkout,
          },
        },
      );

      const data = res.data;

      if (data?.status === "AVAILABLE") {
        localStorage.setItem("tokenIdWompi", data?.payment_source_id);
      }
    } catch (err) {
      const errorMsg =
        err?.response?.data?.message ||
        "Error de conexión. Intenta nuevamente.";
      console.error("Wompi error:", err?.response?.data);
      showAlert("info", errorMsg, 8000);
    }
  }, [showAlert]);

  const handleNext = () => {
    if (currentStep < totalSteps) {
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentStep((prev) => prev + 1);
        setIsTransitioning(false);
      }, 150);
    } else {
      if (formDataOferta.tipoFirma === "fisica") {
        setDialogOpenContratoFirma(true);
      } else {
        handleSubmit();
      }
    }

    // saveOfertCredit({
    //   ...offerCreditStore,
    //   paydayLimit: formDataOferta.paydayLimit,
    //   tipoFirma: formDataOferta.tipoFirma,
    //   email: localStorage.getItem("email"),
    //   phone: localStorage.getItem("phone"),
    // });
  };

  const handleSubmit = async () => {
    try {
      setIsLoadingButton(true);
      localStorage.setItem("type_user", variablesGlobales.typeUSerClient);
      trackEvent("oferta_aceptada", {
        monto: montoElegido(offerCreditStore),
        plazo_dias: vencimientoEnDias,
        tipo_cliente: "renovacion",
      });

      setTimeout(() => {
        let nextStet = 1;
        /* if (
          creditUserStore.renovar === true ||
          creditUserStore.renovar === "true" ||
          creditUserStore.statusCredit === creditStatus.PF ||
          creditUserStore.statusCredit === creditStatus.S
        ) {
          nextStet = 2;
        } */
        if (onStepChange) {
          onStepChange(parentStep + nextStet); // o el número de paso que desees
        }
        updateCredit(false);
        setIsLoadingButton(false);
      }, 3000);
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
    }
  };

  const calcDiscountForReward = useCallback((availableReward) => {
    if (availableReward && availableReward?.rewardHistoryAvailable) {
      let shortCode = availableReward?.shortCodeReward;
      let typeReward = String(shortCode).substring(1, 3);
      if (typeReward === "10") {
        let percentage =
          availableReward?.rewardHistoryAvailable?.percentDiscount;
        let discountReward =
          (firmaElectronicaValueRef.current * percentage) / 100;
        return discountReward;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  }, []);

  const calcFirmaElectronica = useCallback((amount, vencimientoEnDias) => {
    let _firmaElectronica = firmaElectronicaValueRef.current;
    let dctoFirmaElectronica = calcDescuentoFirmaElectronicaV1(
      amount,
      vencimientoEnDias,
    );
    let _firmaElectronicaTotal;
    if (dctoFirmaElectronica === _firmaElectronica) {
      setDctoFirmaElectronica(0);
      _firmaElectronicaTotal = _firmaElectronica;
    } else {
      setDctoFirmaElectronica(dctoFirmaElectronica);
      _firmaElectronicaTotal = _firmaElectronica - dctoFirmaElectronica;
    }
    return _firmaElectronicaTotal;
  }, []);

  const calculateInterest = useCallback((amount, vencimientoEnDias, rate) => {
    let tasa = localStorage.getItem("currentInterestRate");
    let tea = localStorage.getItem("currentInterestTea");
    tea = convertToNumber(tea);
    let tasaUsuraTmlv = tasaUsuraTmlvRateRef.current;
    if (tasaUsuraTmlv === undefined && rate !== undefined) {
      tasaUsuraTmlv = rate;
    }
    tasaUsuraTmlv = parseFloat(tasaUsuraTmlv.replace(",", "."));
    if (!isValidNumber(tea)) tea = 0;

    //si la tasa efectiva anual de interes corriente es mayor a la tasa de usura de la tasa máxima legal permitida se aplica la tasa de usura de la tasa máxima legal permitida
    if (tea > tasaUsuraTmlv) {
      tea = tasaUsuraTmlv;
      localStorage.setItem("currentInterestTea", tea);
      let tasaNueva = calcCurrentInterestTed(tea);
      localStorage.setItem("currentInterestRate", tasaNueva);
      tasa = tasaNueva;
    }
    const interest2 = calcInteresCorrienteV2(amount, vencimientoEnDias, tasa);
    return interest2;
  }, []);

  const calculateTotal = useCallback((amount, vencimientoEnDias) => {
    if (checkFirmaElectronica) {
      let total =
        amount +
        calculateInterest(amount, vencimientoEnDias) +
        calcFirmaElectronica(amount, vencimientoEnDias);
      return total;
    } else {
      let total = amount + calculateInterest(amount, vencimientoEnDias);
      setDctoFirmaElectronica(firmaElectronicaValueRef.current);
      return total;
    }
  }, [checkFirmaElectronica, calculateInterest, calcFirmaElectronica]);

  const calcCurrentInterestTed = (tea) => {
    let interesCorrienteTea = parseFloat(tea);
    let interesCorrienteTem = calcularInteresCorrienteTem(interesCorrienteTea);
    let interesCorrienteTed = calcularInteresCorrienteTed(interesCorrienteTem);
    return interesCorrienteTed;
  };

  const updateCredit = async (isPhysical) => {
    let creditPayload = preparePayload(isPhysical);

    let quotaStatusPayload = {
      cupoUtilizado: String(creditPayload.approvedQuota),
      // cupoDisponible: String(cupoDisponible - creditPayload.approvedQuota),
    };

    await HttpRequest.updateQuotaStatus(
      localStorage.getItem("doc"),
      quotaStatusPayload,
    );

    try {
      await CreditsService.updateCreditFromOfferPage({
        credit: creditPayload,
        creditId: localStorage.getItem("credit_id"),
        documento: localStorage.getItem("doc"),
      });
    } catch (error) {
      console.log("Error al actualizar el credito");
      console.log(error);
    }
  };

  const handleRequestPhysicalSignature = async () => {
    try {
      setIsLoading(true);
      setTitleDialog("Firma fisica");
      setDescriptionDialog(
        "Hemos enviado a tu correo electrónico un email con los documentos que debes firmar.",
      );
      updateCredit(true);

      const response = await apiClient.create(
        REQUEST_PROCESS_PHYSICAL_SIGNATURE,
        {
          documento: localStorage.getItem("doc"),
          creditId: localStorage.getItem("credit_id"),
        },
      );

      if (response.status === 200) {
        const newLimit = limitFirmaFisica + 1;
        setTimeout(() => {
          setDialogOpenContratoFirma(false);
          setIsLoading(false);
          setOpenDialog(true);
          setLimitFirmaFisica(newLimit);
          localStorage.setItem("limitFirmaFisica", String(newLimit));
        }, 5000);
        return;
      }
      setTimeout(() => {
        setDialogOpenContratoFirma(false);
        setIsLoading(false);
      }, 3000);
    } catch (error) {
      setDialogOpenContratoFirma(false);
      setIsLoading(false);
      console.log(error);
      return;
    }
  };

  const preparePayload = (isPhysical = false) => {
    let newCreditData = { ...offerCreditStore };
    newCreditData.totalToPay = total;
    newCreditData.firmaElectronica = !isPhysical ? firmaElectronicaValue : 0;
    newCreditData.dctoFirmaElectronica = !isPhysical ? dctoFirmaElectronica : 0;
    newCreditData.interestRate = !isPhysical ? newCreditData.interestRate : 0;
    newCreditData.tipoFirma = !isPhysical ? "electronica" : "fisica";
    newCreditData.status = "Pendiente de firmar";
    newCreditData.tasaInteresCorriente = localStorage.getItem(
      "currentInterestRate",
    );
    let acceptanceDate = moment().format("DD/MM/YYYY");

    let creditPayload = {
      approvedQuota: newCreditData.selectedQuota,
      requestedAmount: newCreditData.selectedQuota,
      termInDays: newCreditData.termInDays,
      totalToPay: total,
      paymentBalance: total,
      paydayLimit: newCreditData.paydayLimit,
      interestRate: newCreditData.interestRate,
      dctoFirmaElectronica: newCreditData.dctoFirmaElectronica,
      acceptanceDate: checkFirmaElectronica ? acceptanceDate : "",
      tipoFirma: newCreditData.tipoFirma,
      firmaElectronica: newCreditData.firmaElectronica,
      tasaInteresCorriente: newCreditData.tasaInteresCorriente,
    };
    return creditPayload;
  };

  const getAvailableReward = useCallback(async () => {
    try {
      let { data } = await api.get(
        GET_AVAILABLE_REWARD + localStorage.getItem("doc"),
      );
      let availableReward = data?.data;
      return availableReward;
    } catch (error) {
      console.log(error);
      return {};
    }
  }, []);

  const loadInfoQuota = useCallback(async () => {
    try {
      const data = await HttpRequest.getQuotaStatus(
        localStorage.getItem("doc"),
      );
      return data.message.info;
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    loadOfertCredit();
    loadUser();
  }, [loadOfertCredit, loadUser]);

  useEffect(() => {
    const creditAprobate = localStorage.getItem("credit_aprobate");
    const approvedViewed = localStorage.getItem("approved_viewed");

    if (creditAprobate === "false" || !creditAprobate) {
      setIsApprovedCridit(false);
      return;
    }

    if (offerCreditStore) {
      trackEventOnce("oferta-vista-renovacion", "oferta_vista", {
        rango_monto: rangoMonto(offerCreditStore.approvedQuota),
        tipo_cliente: "renovacion",
      });
      setFormDataOferta({
        ...offerCreditStore,
        approvedQuota: offerCreditStore.approvedQuota,
        requestedAmount: offerCreditStore.selectedQuota,
        selectedQuota: offerCreditStore.selectedQuota
          ? offerCreditStore.selectedQuota
          : offerCreditStore.approvedQuota,
        paydayLimit: offerCreditStore.paydayLimit,
        termInDays: offerCreditStore.termInDays,
        tipoFirma: offerCreditStore.tipoFirma,
      });

      setSelectedQuota(
        offerCreditStore.selectedQuota
          ? offerCreditStore.selectedQuota
          : offerCreditStore.approvedQuota,
      );
      // setApprovedQuota(offerCreditStore.approvedQuota);
    }

    if (approvedViewed === "true") {
      setIsApprovedCridit(false);
      return;
    }

    if (creditAprobate === "true" && viewAprobate === 0) {
      setIsApprovedCridit(true);
      setTimeout(() => {
        setIsApprovedCridit(false);
        setViewAprobate(1);
        localStorage.setItem("approved_viewed", "true");
      }, 4000);
    }

    const limitFirma = localStorage.getItem("limitFirmaFisica");
    setLimitFirmaFisica(limitFirma ? parseInt(limitFirma) : 0);
  }, [offerCreditStore, viewAprobate]);

  useEffect(() => {
    if (!formDataOferta.paydayLimit) return;

    const d = moment(formDataOferta.paydayLimit, "DD/MM/YYYY");
    const diff = d.diff(moment(), "days") + 1;

    setVencimientoEnDias(diff);
  }, [formDataOferta.paydayLimit]);

  useEffect(() => {
    if (vencimientoEnDias <= 0) return;

    (async () => {
      let _tmlvData = localStorage.getItem("tmlv");
      let rate = "25,00";

      if (_tmlvData) {
        const Tmlv = JSON.parse(_tmlvData);
        rate = Tmlv?.[0]?.rate ?? "25,00";
        setTasaUsuraTmlvRate(rate);
      }

      await getInterest();

      const _interest = calculateInterest(
        convertToNumber(formDataOferta.selectedQuota),
        vencimientoEnDias,
        rate,
      );

      setInterest(_interest);

      await getAndSetInterestTea();
    })();
  }, [vencimientoEnDias, formDataOferta.selectedQuota, calculateInterest]);

  useEffect(() => {
    if (vencimientoEnDias <= 0) return;

    setFirmaElectronicaValue(variablesGlobales.firmaElectronica);

    const discount = calcDiscountForReward(rewardHistoryAvailable);

    setDiscountForReward(discount);

    const _total = calculateTotal(
      convertToNumber(formDataOferta.selectedQuota),
      vencimientoEnDias,
    );

    setTotal(checkFirmaElectronica ? _total - discount : _total);
  }, [
    rewardHistoryAvailable,
    checkFirmaElectronica,
    calcDiscountForReward,
    calculateTotal,
    interest,
    vencimientoEnDias,
    formDataOferta.selectedQuota,
  ]);

  useEffect(() => {
    setFormDataOferta((prev) => ({
      ...prev,
      total,
    }));
  }, [total]);
  useEffect(() => {
    validateTokenization();
  }, [validateTokenization]);

  useEffect(() => {
    const initializeData = async () => {
      if (!offerCreditStore || hasValidatedRef.current) return;

      hasValidatedRef.current = true;

      let initialData = { ...offerCreditStore };

      const { isChanges, creditChanges } =
        await validateCreditDatesFromViewOffer(offerCreditStore);

      if (isChanges && creditChanges) {
        initialData = {
          ...initialData,
          approvedDate: creditChanges.approvedDate,
          paydayLimit: creditChanges.paydayLimit,
          termInDays: creditChanges.termInDays,
          totalToPay: creditChanges.totalToPay,
          versionTarifas: creditChanges.versionTarifas,
          versionContrato: creditChanges.versionContrato,
        };

        saveOfertCredit({
          ...offerCreditStore,
          approvedDate: creditChanges.approvedDate,
          paydayLimit: creditChanges.paydayLimit,
          termInDays: creditChanges.termInDays,
          totalToPay: creditChanges.totalToPay,
          versionTarifas: creditChanges.versionTarifas,
          versionContrato: creditChanges.versionContrato,
        });
      }

      // Setear los valores en el estado del formulario
      setFormDataOferta({
        ...initialData,
        approvedDate: initialData.approvedDate,
        selectedQuota: initialData.approvedDate,
        paydayLimit: initialData.paydayLimit,
        termInDays: initialData.termInDays,
        totalToPay: initialData.totalToPay,
        versionTarifas: initialData.versionTarifas,
        versionContrato: initialData.versionContrato,
      });
    };

    initializeData();
  }, [offerCreditStore, saveOfertCredit]);

  useEffect(() => {
    const validSessionAndTokenJwt = async () => {
      try {
        let isValidToken = await validateSessionAndJwtToken();
        return isValidToken;
      } catch (error) {
        return false;
      }
    };

    const loadQuotaStatus = async () => {
      let quotaStatus = await loadInfoQuota();
      return quotaStatus;
    };

    validSessionAndTokenJwt()
      .then(async (isValidToken) => {
        if (isValidToken) {
          let availableReward = await getAvailableReward();
          setRewardHistoryAvailable(availableReward);
          let cupo = await loadQuotaStatus();
          let cupoDisponible = 0;
          if (cupo && cupo.cupoUtilizado) {
            cupoDisponible =
              Number(cupo.cupoUtilizado) === 0
                ? cupo.cupoAprobado
                : cupo.cupoDisponible;
          } else {
            cupoDisponible = cupo?.cupoDisponible;
          }
          setCupoDisponible(cupoDisponible);
          setIsLoading(false);
          return;
        } else {
          returnToSignin(navigate);
        }
      })
      .catch((e) => {
        console.log(e);
        returnToSignin(navigate);
      });
  }, [getAvailableReward, loadInfoQuota, navigate]);

  useEffect(() => {
    const canvas = starsRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    let W = 0;
    let H = 0;
    let stars = [];
    let animationId;

    const resize = () => {
      W = canvas.width = window.innerWidth;
      H = canvas.height = window.innerHeight;
    };

    const createStar = () => ({
      x: Math.random() * W,
      y: Math.random() * H,
      r: Math.random() * 1 + 0.2,
      a: Math.random(),
      da: (Math.random() * 0.005 + 0.001) * (Math.random() < 0.5 ? 1 : -1),
    });

    const init = () => {
      resize();
      stars = Array.from({ length: 160 }, createStar);
    };

    const draw = () => {
      ctx.clearRect(0, 0, W, H);

      for (const star of stars) {
        star.a += star.da;

        if (star.a <= 0.04 || star.a >= 1) {
          star.da *= -1;
        }

        ctx.beginPath();
        ctx.arc(star.x, star.y, star.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255,255,255,${star.a.toFixed(2)})`;
        ctx.fill();
      }

      animationId = requestAnimationFrame(draw);
    };

    window.addEventListener("resize", resize);

    init();
    draw();

    return () => {
      window.removeEventListener("resize", resize);
      cancelAnimationFrame(animationId);
    };
  }, []);

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        if (!isDesktop) {
          return (
            <div
              className="space-y-6"
              style={{
                margin: "0px 0px 30px",
              }}
            >
              <div className="bg-muted rounded-lg p-4 space-y-3">
                <div className="gap-8 text-sm flex flex-col text-center">
                  {/* --- Cupo aprobado y plazo --- */}
                  <div className="flex flex-row justify-between w-full">
                    <div className="flex flex-col">
                      <span className=" text-muted-foreground text-lg">
                        Cupo aprobado:
                      </span>
                      <div className="flex justify-center items-center gap-2 flex-row">
                        <span
                          className="font-bold2 text-purple text-xl"
                          style={{
                            color: "#C9B8FF",
                          }}
                        >
                          <Numeral
                            className="text-2xl font-bold2"
                            format={"$0,0"}
                            value={formDataOferta.selectedQuota}
                          />
                        </span>
                      </div>
                      <button
                        type="button"
                        onClick={handleToggleDialogCupo}
                        className="text-purple text-sm"
                        style={{
                          color: "#C9B8FF",
                          cursor: "pointer",
                        }}
                      >
                        Editar cupo
                      </button>

                      <BottomSheet
                        open={openSheetRangoQupo}
                        onOpenChange={setOpenSheetRangoQupo}
                        headerContent={
                          <h2 className="font-semibold2">Cupo aprobado</h2>
                        }
                        footerContent={
                          <div className="flex gap-5 h-16">
                            <PrevButton
                              onBack={() => {
                                setOpenSheetRangoQupo(false);
                              }}
                              label={"Cancelar"}
                            />
                            <NextButton
                              onNext={(e) => {
                                setOpenSheetRangoQupo(false);
                                handleInputChange(
                                  (e = {
                                    target: {
                                      name: "selectedQuota",
                                      value: selectedQuota,
                                    },
                                  }),
                                );
                                saveOfertCredit({
                                  ...offerCreditStore,
                                  selectedQuota: selectedQuota,
                                });
                              }}
                              label={"Seleccionar"}
                            />
                          </div>
                        }
                      >
                        <p
                          className="text-center mb-4 font-semibold2"
                          style={{
                            width: "195px",
                            color: "#FAFAFA",
                            fontSize: "15px",
                          }}
                        >
                          Modifica tu cupo:
                        </p>

                        <div className="space-y-3 w-full mb-3">
                          <div style={{ margin: "50px auto" }}>
                            <AmountSlider
                              min={200000}
                              max={Number(cupoDisponible)}
                              value={selectedQuota}
                              step={10000}
                              onChange={(value) => {
                                setSelectedQuota(value);
                              }}
                            />
                          </div>
                        </div>
                      </BottomSheet>
                    </div>

                    <div className="flex flex-col">
                      <span className=" text-muted-foreground text-xl">
                        El plazo seran:
                      </span>
                      <p className="font-bold2 text-2xl">
                        {vencimientoEnDias} días
                      </p>
                    </div>
                  </div>

                  {/* --- Fecha de pago y total --- */}
                  <div className="flex flex-row justify-between w-full">
                    <div className="flex justify-center items-center flex-col">
                      <span className=" text-muted-foreground text-lg">
                        Fecha de pago:
                      </span>
                      <p className="font-bold2 text-2xl">
                        {formDataOferta.paydayLimit}
                      </p>
                      <button
                        type="button"
                        onClick={handleToggleDialog}
                        className="text-purple text-sm"
                        style={{
                          color: "#C9B8FF",
                          cursor: "pointer",
                        }}
                      >
                        Editar
                      </button>

                      <BottomSheet
                        open={openSheetFechas}
                        onOpenChange={setOpenSheetFechas}
                        headerContent={
                          <h2 className="font-semibold2">Fechas de Pago</h2>
                        }
                        footerContent={
                          <div className="flex gap-5 h-16">
                            <PrevButton
                              onBack={() => {
                                setOpenSheetFechas(false);
                              }}
                              label={"Cancelar"}
                            />
                            <NextButton
                              onNext={(e) => {
                                setOpenSheetFechas(false);

                                handleInputChange(
                                  (e = {
                                    target: {
                                      name: "paydayLimit",
                                      value: fechaSelected,
                                    },
                                  }),
                                );
                              }}
                              label={"Seleccionar"}
                              disabled={
                                fechaSelected === formDataOferta.paydayLimit
                              }
                            />
                          </div>
                        }
                      >
                        <p
                          className="text-center mb-4 font-semibold2"
                          style={{
                            width: "195px",
                            color: "#FAFAFA",
                            fontSize: "15px",
                          }}
                        >
                          Escoge una de las fechas de pago disponibles:
                        </p>

                        <div className="space-y-3 w-full mb-3">
                          <div className="mt-2">
                            <FechasRadioGroup
                              amount={formDataOferta.approvedQuota}
                              creditUser={formDataOferta}
                              onSelectDate={(fechaSeleccionada) => {
                                setFechaSelected(fechaSeleccionada);
                              }}
                            />
                          </div>
                        </div>
                      </BottomSheet>
                    </div>

                    <div className="flex flex-col">
                      <span className=" text-muted-foreground text-lg">
                        Total a pagar:
                      </span>
                      <div className="flex justify-center items-center gap-2 flex-row">
                        <span className="font-bold2 text-xl">
                          <Numeral
                            className="text-2xl font-bold2"
                            format={"$0,0"}
                            value={total}
                          />
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* --- Modalidad de firma --- */}
                  <div className="flex flex-col gap-4">
                    <label
                      htmlFor="acceptTerms"
                      className="text-lg font-semibold2"
                    >
                      Modalidad de firma
                    </label>
                    <label
                      htmlFor="acceptTerms"
                      className="text-3xl font-bold2"
                    >
                      {formDataOferta.tipoFirma === "electronica"
                        ? "Firma Electrónica"
                        : "Firma Manuscrita"}
                    </label>

                    <button
                      type="button"
                      onClick={handleToggleDialogFirma}
                      className="text-purple text-sm"
                      style={{
                        color: "#C9B8FF",
                      }}
                    >
                      Elegir otra opción
                    </button>

                    {/* --- Aquí se invoca el BottomSheet controlado --- */}
                    <BottomSheet
                      open={openSheetFirma}
                      onOpenChange={setOpenSheetFirma}
                      headerContent={
                        <h2 className="font-semibold2">Modalidad de firma</h2>
                      }
                      footerContent={
                        <div className="flex gap-5 h-16">
                          <PrevButton
                            onBack={() => {
                              setOpenSheetFirma(false);
                            }}
                            label={"Cancelar"}
                          />
                          <NextButton
                            onNext={(e) => {
                              setOpenSheetFirma(false);
                              handleInputChange(
                                (e = {
                                  target: {
                                    name: "tipoFirma",
                                    value: isSelectedTipoFirma,
                                  },
                                }),
                              );
                              saveOfertCredit({
                                ...offerCreditStore,
                                tipoFirma: isSelectedTipoFirma,
                              });
                            }}
                            label={"Seleccionar"}
                            disabled={
                              isSelectedTipoFirma === formDataOferta.tipoFirma
                            }
                          />
                        </div>
                      }
                    >
                      <p
                        className="text-center mb-4 font-semibold2"
                        style={{
                          width: "220px",
                          color: "#FAFAFA",
                          fontSize: "15px",
                        }}
                      >
                        ¿Cómo quieres firmar los documentos de tu crédito?
                      </p>

                      <div className="space-y-3 w-full flex flex-col gap-6 mb-3 mt-5">
                        <button
                          onClick={() => changeTipoFirma("electronica")}
                          name="tipoFirma"
                          className={`w-full flex justify-between items-center px-4 py-3 border border-gray-300 text-gray-400`}
                          style={{
                            height: "60px",
                            borderRadius: "2.5rem",
                            backgroundColor:
                              isSelectedTipoFirma === "electronica"
                                ? "#565584"
                                : "#2C2447",
                            color:
                              isSelectedTipoFirma === "electronica"
                                ? "#C9B8FF"
                                : "#BEBCC2",
                            border:
                              isSelectedTipoFirma === "electronica"
                                ? "1px solid #C9B8FF"
                                : "none",
                            cursor: "pointer",
                          }}
                        >
                          <div className="flex flex-row items-center gap-4">
                            <Signature
                              className={`w-7 h-7`}
                              style={{
                                color:
                                  isSelectedTipoFirma === "electronica"
                                    ? "#C9B8FF"
                                    : "#BEBCC2",
                              }}
                              strokeWidth={2.5}
                            />
                            <span
                              className={`text-xl`}
                              style={{
                                color:
                                  isSelectedTipoFirma === "electronica"
                                    ? "#C9B8FF"
                                    : "#BEBCC2",
                                fontWeight: "400",
                                fontFamily: "GT Walsheim Pro",
                              }}
                            >
                              Firma Electrónica
                            </span>
                          </div>
                          <Check
                            className={`w-7 h-7`}
                            style={{
                              color:
                                isSelectedTipoFirma === "electronica"
                                  ? "#C9B8FF"
                                  : "#BEBCC2",
                            }}
                            strokeWidth={2.5}
                          />
                        </button>
                        <button
                          onClick={() => changeTipoFirma("fisica")}
                          name="tipoFirma"
                          className={`w-full  flex justify-between items-center px-4 py-3 border border-gray-300 text-grayP`}
                          style={{
                            backgroundColor:
                              isSelectedTipoFirma === "fisica"
                                ? "#565584"
                                : "#2C2447",
                            color:
                              isSelectedTipoFirma === "fisica"
                                ? "#C9B8FF"
                                : "#BEBCC2",
                            height: "60px",
                            borderRadius: "2.5rem",
                            border:
                              isSelectedTipoFirma === "fisica"
                                ? "1px solid #C9B8FF"
                                : "none",
                            cursor: "pointer",
                          }}
                        >
                          <div className="flex flex-row items-center gap-4">
                            <Edit3
                              className={`w-7 h-7`}
                              style={{
                                color:
                                  isSelectedTipoFirma === "fisica"
                                    ? "#C9B8FF"
                                    : "#BEBCC2",
                              }}
                              strokeWidth={2.5}
                            />
                            <span
                              className={`text-xl`}
                              style={{
                                color:
                                  isSelectedTipoFirma === "fisica"
                                    ? "#C9B8FF"
                                    : "#BEBCC2",
                                fontWeight: "400",
                                fontFamily: "GT Walsheim Pro",
                              }}
                            >
                              Firma Manuscrita
                            </span>
                          </div>
                          <Check
                            className={`w-7 h-7`}
                            style={{
                              color:
                                isSelectedTipoFirma === "fisica"
                                  ? "#C9B8FF"
                                  : "#BEBCC2",
                            }}
                            strokeWidth={2.5}
                          />
                        </button>
                      </div>
                    </BottomSheet>
                  </div>
                </div>
              </div>

              {/* --- Botón inferior --- */}
              <button
                onClick={() => handleToggleDialogContratos()}
                type="button"
                style={{
                  height: "70px",
                  borderRadius: "2.5rem",
                  backgroundColor: "#565584",
                  cursor: "pointer",
                }}
                className={`flex w-full items-center justify-center gap-3 transition-all duration-200 text-base sm:text-xl`}
              >
                <FilesIcon
                  className="w-7 h-7"
                  style={{
                    color: "#C9B8FF",
                  }}
                />
                <p
                  className="text-purple text-xl"
                  style={{
                    color: "#C9B8FF",
                  }}
                >
                  Contrato y pagaré
                </p>
              </button>

              <footer
                className="w-full sm:max-w-md mx-auto sm:px-0"
                style={{
                  marginBottom: "4px",
                }}
              >
                <div className="flex flex-col">
                  <div className="w-full flex gap-4 flex-row sm:flex-row">
                    <button
                      type="button"
                      onClick={() => handleNext()}
                      disabled={isLoadingButton}
                      style={{
                        height: "70px",
                        borderRadius: "2.5rem",
                        fontSize: "1.2rem",
                        fontWeight: "400",
                        backgroundColor: isLoadingButton
                          ? "#2C2447"
                          : "#7E02FC",
                        cursor: "pointer",
                      }}
                      className={`flex items-center justify-center gap-3 px-4 py-3 transition-all duration-200 flex-1 font-medium text-base ${!isLoadingButton
                        ? "text-white hover:bg-purpleDark"
                        : " text-gray-500 cursor-not-allowed"
                        }`}
                    >
                      {isLoadingButton ? (
                        <>
                          <div className="w-6 h-6 text-white border-2 border-current border-t-transparent rounded-full animate-spin" />
                          Viajando...
                        </>
                      ) : (
                        <>
                          <p
                            className="text-white"
                            style={{ fontSize: "1.5rem" }}
                          >
                            Continuar
                          </p>
                          <ArrowRight className="w-6 h-6" />
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </footer>

              <BottomSheet
                open={dialogOpenContrato}
                onOpenChange={setDialogOpenContrato}
                headerContent={
                  <div
                    className="flex rounded-2xl mx-auto font-semibold2"
                    style={{
                      backgroundColor: "#2C2447",
                      padding: "8px",
                      width: "200px",
                      margin: "0px",
                    }}
                  >
                    <button
                      onClick={() => handleTabClick("contrato")}
                      className={`flex-1 py-2 text-sm rounded-xl transition-all ${activeTab === "contrato"
                        ? "bg-purpleM text-white "
                        : "text-tgray"
                        }`}
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      Contrato
                    </button>
                    <button
                      onClick={() => handleTabClick("pagare")}
                      className={`flex-1 py-2 text-sm rounded-xl transition-all ${activeTab === "pagare"
                        ? "bg-purpleM text-white "
                        : "text-tgray"
                        }`}
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      Pagaré
                    </button>
                  </div>
                }
              >
                <div className="space-y-3 w-full">
                  {activeTab === "contrato" ? (
                    <div
                      className="h-full rounded-t-3xl overflow-auto"
                      style={{
                        backgroundColor: "#2C2447",
                        color: "#FAFAFA",
                      }}
                    >
                      <ContractV3
                        basicInfo={creditUserStore}
                        userinfo={offerCreditStore}
                        creditUser={offerCreditStore}
                        firmaElectronica={
                          formDataOferta.tipoFirma === "electronica"
                            ? firmaElectronicaValue
                            : 0
                        }
                        dctoFirmaElectronica={
                          formDataOferta.tipoFirma === "electronica"
                            ? dctoFirmaElectronica
                            : 0
                        }
                        total={total}
                      />
                    </div>
                  ) : (
                    <div
                      className="h-full rounded-t-3xl overflow-auto"
                      style={{
                        backgroundColor: "#2C2447",
                        color: "#FAFAFA",
                      }}
                    >
                      <PromissoryV2
                        basicInfo={creditUserStore}
                        userinfo={offerCreditStore}
                      />
                    </div>
                  )}
                </div>
              </BottomSheet>

              <BottomSheet
                open={dialogOpenContratoFirma}
                onOpenChange={setDialogOpenContratoFirma}
                isDesktop={false}
                headerContent={
                  <h2 className="font-semibold2">Firma manuscrita</h2>
                }
                footerContent={
                  <button
                    onClick={(e) => {
                      handleRequestPhysicalSignature();
                    }}
                    className="w-full bg-purple text-white py-3 gap-3 justify-center flex items-center"
                    disabled={isLoading || limitFirmaFisica > 2}
                    style={{
                      borderRadius: "2.5rem",
                      height: "3.5rem",
                      fontSize: "20px",
                      backgroundColor:
                        isLoading || limitFirmaFisica > 2
                          ? "#2C2447"
                          : "#7E02FC",
                      cursor:
                        isLoading || limitFirmaFisica > 2
                          ? "not-allowed"
                          : "pointer",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {isLoading ? (
                      <>
                        <div className="w-6 h-6 border-2 border-current border-t-transparent rounded-full animate-spin" />
                        Viajando...
                      </>
                    ) : (
                      <p style={{ fontSize: "1.1rem" }}>{"Iniciar Proceso"}</p>
                    )}
                  </button>
                }
              >
                <div className="space-y-3 w-full">
                  <div
                    className="h-full rounded-t-3xl overflow-auto"
                    style={{
                      backgroundColor: "#2C2447",
                      color: "#FAFAFA",
                    }}
                  >
                    <ManualSignV3
                      isOpen={dialogOpenContratoFirma}
                      setOpen={setDialogOpenContratoFirma}
                    />
                  </div>
                </div>
              </BottomSheet>
            </div>
          );
        }
        if (isDesktop) {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                width: "-webkit-fill-available",
                height: isDesktopReize ? "-webkit-fill-available" : "100%",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  margin: 0,
                  width: "100%",
                  height: "100%",
                  paddingLeft: "clamp(60px, 7vw, 100px)",
                  paddingRight: "clamp(60px, 7vw, 100px)",
                  display: "flex",
                  flexDirection: "column",
                  overflow: "visible",
                  gap: "calc(15% - 1px)",
                  marginBottom: "30px",
                }}
              >
                {/* Header */}
                <div
                  style={{
                    marginBottom: "clamp(5px, 1vw, 40px)",
                  }}
                >
                  <h1
                    className="font-bold2"
                    style={{
                      fontSize: "clamp(24px, 2.5vw, 48px)",
                      color: "#FAFAFA",
                      lineHeight: "1.3",
                      wordWrap: "break-word",
                    }}
                  >
                    {creditUserStore?.firstname
                      ? `¡${creditUserStore.firstname}!`
                      : ""}{" "}
                    Revisa las condiciones de tu crédito.
                  </h1>

                  <p
                    style={{
                      fontSize: "clamp(14px, 1.2vw, 18px)",
                      color: "#BEBCC2",
                      lineHeight: "1.5",
                      wordWrap: "break-word",
                    }}
                  >
                    {creditUserStore?.firstname
                      ? `¡${creditUserStore.firstname}!`
                      : ""}{" "}
                    Tus condiciones de crédito están listas. Revísalas y firma
                    la oferta para desembolsar.
                  </p>
                </div>

                {/* Grid de información - 3 columnas */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(3, 1fr)",
                    gap: "0px 10px",
                    marginBottom: "clamp(30px, 4vh, 40px)",
                  }}
                >
                  {/* Cupo aprobado */}
                  <div style={{ textAlign: "center" }}>
                    <p
                      style={{
                        fontSize: "clamp(14px, 1.5vw, 20px)",
                        color: "#BEBCC2",
                      }}
                    >
                      Cupo aprobado:
                    </p>
                    <h2
                      className="font-bold2"
                      style={{
                        fontSize: "clamp(32px, 3vw, 70px)",
                        color: "#C9B8FF",
                        fontWeight: "700",
                        lineHeight: "1",
                      }}
                    >
                      <Numeral
                        format={"$0,0"}
                        value={formDataOferta.selectedQuota}
                      />
                    </h2>

                    <button
                      type="button"
                      onClick={handleToggleDialogCupo}
                      className="text-purple text-sm"
                      style={{
                        color: "#C9B8FF",
                        cursor: "pointer",
                      }}
                    >
                      Editar cupo
                    </button>

                    <BottomSheet
                      open={openSheetRangoQupo}
                      onOpenChange={setOpenSheetRangoQupo}
                      headerContent={
                        <h2 className="font-semibold2">Cupo aprobado</h2>
                      }
                      isDesktop={isDesktop}
                      footerContent={
                        <div className="flex gap-5 h-16">
                          <PrevButton
                            onBack={() => {
                              setOpenSheetRangoQupo(false);
                            }}
                            label={"Cancelar"}
                          />
                          <NextButton
                            onNext={(e) => {
                              setOpenSheetRangoQupo(false);

                              handleInputChange(
                                (e = {
                                  target: {
                                    name: "selectedQuota",
                                    value: selectedQuota,
                                  },
                                }),
                              );
                              saveOfertCredit({
                                ...offerCreditStore,
                                selectedQuota: selectedQuota,
                              });
                            }}
                            label={"Seleccionar"}
                          />
                        </div>
                      }
                    >
                      <p
                        className="text-center mb-4 font-semibold2"
                        style={{
                          width: "195px",
                          color: "#FAFAFA",
                          fontSize: "15px",
                        }}
                      >
                        Modifica tu cupo:
                      </p>

                      <div className="space-y-3 w-full mb-3">
                        <div style={{ margin: "50px auto" }}>
                          <AmountSlider
                            min={200000}
                            max={Number(cupoDisponible)}
                            value={selectedQuota}
                            step={10000}
                            onChange={(value) => {
                              setSelectedQuota(value);
                            }}
                          />
                        </div>
                      </div>
                    </BottomSheet>
                  </div>

                  {/* El plazo serán */}
                  <div style={{ textAlign: "center" }}>
                    <p
                      style={{
                        fontSize: "clamp(14px, 1.5vw, 20px)",
                        color: "#BEBCC2",
                      }}
                    >
                      El plazo serán:
                    </p>
                    <p
                      className="font-bold2"
                      style={{
                        fontSize: "clamp(16px, 2vw, 28px)",
                        color: "#FFFFFF",
                      }}
                    >
                      {vencimientoEnDias} días
                    </p>
                  </div>

                  {/* Modalidad de Firma */}
                  <div style={{ textAlign: "center" }}>
                    <p
                      style={{
                        fontSize: "clamp(14px, 1.5vw, 20px)",
                        color: "#BEBCC2",
                      }}
                      className="font-semibold2"
                    >
                      Modalidad de Firma:
                    </p>
                    <p
                      className="font-bold2"
                      style={{
                        fontSize: "clamp(16px, 2vw, 28px)",
                        color: "#FFFFFF",
                      }}
                    >
                      {formDataOferta.tipoFirma === "electronica"
                        ? "Firma Electrónica"
                        : "Firma Manuscrita"}
                    </p>
                    <button
                      type="button"
                      onClick={handleToggleDialogFirma}
                      className="font-bold2"
                      style={{
                        color: "#C9B8FF",
                        fontSize: "clamp(12px, 1vw, 16px)",
                        cursor: "pointer",
                      }}
                    >
                      Elegir otra opción
                    </button>

                    <BottomSheet
                      open={openSheetFirma}
                      onOpenChange={setOpenSheetFirma}
                      headerContent={
                        <h2 className="font-semibold2">Modalidad de firma</h2>
                      }
                      isDesktop={isDesktop}
                      footerContent={
                        <div className="flex gap-5 h-16">
                          <PrevButton
                            onBack={() => {
                              setOpenSheetFirma(false);
                            }}
                            label={"Cancelar"}
                          />
                          <NextButton
                            onNext={(e) => {
                              setOpenSheetFirma(false);
                              handleInputChange(
                                (e = {
                                  target: {
                                    name: "tipoFirma",
                                    value: isSelectedTipoFirma,
                                  },
                                }),
                              );
                              saveOfertCredit({
                                ...offerCreditStore,
                                tipoFirma: isSelectedTipoFirma,
                              });
                            }}
                            label={"Seleccionar"}
                            disabled={
                              isSelectedTipoFirma === formDataOferta.tipoFirma
                            }
                          />
                        </div>
                      }
                    >
                      <p
                        className="text-center mb-4 font-semibold2"
                        style={{
                          width: "220px",
                          color: "#FAFAFA",
                          fontSize: "clamp(13px, 1.2vw, 16px)",
                        }}
                      >
                        ¿Cómo quieres firmar los documentos de tu crédito?
                      </p>

                      <div className="space-y-3 w-full flex flex-col gap-6 mb-3 mt-5">
                        <button
                          onClick={() => changeTipoFirma("electronica")}
                          name="tipoFirma"
                          className="w-full flex justify-between items-center px-4 py-3 border border-gray-300 text-gray-400"
                          style={{
                            height: "60px",
                            borderRadius: "2.5rem",
                            backgroundColor:
                              isSelectedTipoFirma === "electronica"
                                ? "#565584"
                                : "#2C2447",
                            color:
                              isSelectedTipoFirma === "electronica"
                                ? "#C9B8FF"
                                : "#BEBCC2",
                            border:
                              isSelectedTipoFirma === "electronica"
                                ? "1px solid #C9B8FF"
                                : "none",
                            cursor: "pointer",
                          }}
                        >
                          <div className="flex flex-row items-center gap-4">
                            <Signature
                              className="w-7 h-7"
                              style={{
                                color:
                                  isSelectedTipoFirma === "electronica"
                                    ? "#C9B8FF"
                                    : "#BEBCC2",
                              }}
                              strokeWidth={2.5}
                            />
                            <span
                              style={{
                                fontSize: "clamp(16px, 1.5vw, 20px)",
                                color:
                                  isSelectedTipoFirma === "electronica"
                                    ? "#C9B8FF"
                                    : "#BEBCC2",
                                fontWeight: "400",
                                fontFamily: "GT Walsheim Pro",
                              }}
                            >
                              Firma Electrónica
                            </span>
                          </div>
                          <Check
                            className="w-7 h-7"
                            style={{
                              color:
                                isSelectedTipoFirma === "electronica"
                                  ? "#C9B8FF"
                                  : "#BEBCC2",
                            }}
                            strokeWidth={2.5}
                          />
                        </button>
                        <button
                          onClick={() => changeTipoFirma("fisica")}
                          name="tipoFirma"
                          className="w-full flex justify-between items-center px-4 py-3 border border-gray-300 text-grayP"
                          style={{
                            backgroundColor:
                              isSelectedTipoFirma === "fisica"
                                ? "#565584"
                                : "#2C2447",
                            color:
                              isSelectedTipoFirma === "fisica"
                                ? "#C9B8FF"
                                : "#BEBCC2",
                            height: "60px",
                            borderRadius: "2.5rem",
                            border:
                              isSelectedTipoFirma === "fisica"
                                ? "1px solid #C9B8FF"
                                : "none",
                            cursor: "pointer",
                          }}
                        >
                          <div className="flex flex-row items-center gap-4">
                            <Edit3
                              className="w-7 h-7"
                              style={{
                                color:
                                  isSelectedTipoFirma === "fisica"
                                    ? "#C9B8FF"
                                    : "#BEBCC2",
                              }}
                              strokeWidth={2.5}
                            />
                            <span
                              style={{
                                fontSize: "clamp(16px, 1.5vw, 20px)",
                                color:
                                  isSelectedTipoFirma === "fisica"
                                    ? "#C9B8FF"
                                    : "#BEBCC2",
                                fontWeight: "400",
                                fontFamily: "GT Walsheim Pro",
                              }}
                            >
                              Firma Manuscrita
                            </span>
                          </div>
                          <Check
                            className="w-7 h-7"
                            style={{
                              color:
                                isSelectedTipoFirma === "fisica"
                                  ? "#C9B8FF"
                                  : "#BEBCC2",
                            }}
                            strokeWidth={2.5}
                          />
                        </button>
                      </div>
                    </BottomSheet>
                  </div>

                  {/* Fecha de pago */}
                  <div style={{ textAlign: "center" }}>
                    <p
                      style={{
                        fontSize: "clamp(14px, 1.5vw, 20px)",
                        color: "#BEBCC2",
                      }}
                    >
                      Fecha de pago:
                    </p>
                    <p
                      className="font-bold2"
                      style={{
                        fontSize: "clamp(16px, 2vw, 28px)",
                        color: "#FFFFFF",
                      }}
                    >
                      {formDataOferta.paydayLimit}
                    </p>
                    <button
                      type="button"
                      onClick={handleToggleDialog}
                      className="font-bold2"
                      style={{
                        color: "#C9B8FF",
                        fontSize: "clamp(12px, 1vw, 16px)",
                        cursor: "pointer",
                      }}
                    >
                      Editar
                    </button>

                    <BottomSheet
                      open={openSheetFechas}
                      onOpenChange={setOpenSheetFechas}
                      headerContent={
                        <h2 className="font-semibold2">Fechas de Pago</h2>
                      }
                      isDesktop={isDesktop}
                      footerContent={
                        <div className="flex gap-5 h-16">
                          <PrevButton
                            onBack={() => {
                              setOpenSheetFechas(false);
                            }}
                            label={"Cancelar"}
                          />
                          <NextButton
                            onNext={(e) => {
                              setOpenSheetFechas(false);
                              handleInputChange(
                                (e = {
                                  target: {
                                    name: "paydayLimit",
                                    value: fechaSelected,
                                  },
                                }),
                              );
                              saveOfertCredit({
                                ...offerCreditStore,
                                paydayLimit: fechaSelected,
                              });
                            }}
                            label={"Seleccionar"}
                            disabled={
                              fechaSelected === formDataOferta.paydayLimit
                            }
                          />
                        </div>
                      }
                    >
                      <p
                        className="text-center mb-4 font-semibold2"
                        style={{
                          width: "195px",
                          color: "#FAFAFA",
                          fontSize: "clamp(13px, 1.2vw, 16px)",
                        }}
                      >
                        Escoge una de las fechas de pago disponibles:
                      </p>

                      <div className="space-y-3 w-full mb-3">
                        <div className="mt-2">
                          <FechasRadioGroup
                            Amount={formDataOferta.approvedQuota}
                            creditUser={formDataOferta}
                            onSelectDate={(fechaSeleccionada) => {
                              setFechaSelected(fechaSeleccionada);
                            }}
                          />
                        </div>
                      </div>
                    </BottomSheet>
                  </div>

                  {/* Total a pagar */}
                  <div style={{ textAlign: "center" }}>
                    <p
                      style={{
                        fontSize: "clamp(14px, 1.5vw, 20px)",
                        color: "#BEBCC2",
                      }}
                    >
                      Total a pagar:
                    </p>
                    <p
                      className="font-bold2"
                      style={{
                        fontSize: "clamp(16px, 2vw, 28px)",
                        color: "#FFFFFF",
                      }}
                    >
                      <Numeral format={"$0,0"} value={total} />
                    </p>
                  </div>

                  {/* Botón Ver Contrato y Pagaré */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: "clamp(15px, 4vh, 40px)",
                    }}
                  >
                    <button
                      onClick={() => handleToggleDialogContratos()}
                      type="button"
                      style={{
                        height: "clamp(48px, 5vh, 56px)",
                        borderRadius: "2rem",
                        backgroundColor: "#565584",
                        padding: "23px 14px",
                        border: "none",
                        cursor: "pointer",
                        transition: "all 0.2s",
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                      }}
                      className="hover:opacity-90"
                    >
                      <FilesIcon
                        style={{
                          width: "clamp(18px, 1.8vw, 22px)",
                          height: "clamp(18px, 1.8vw, 22px)",
                          color: "#C9B8FF",
                        }}
                      />
                      <span
                        style={{
                          color: "#C9B8FF",
                          fontSize: "clamp(14px, 1.2vw, 18px)",
                          fontWeight: "500",
                        }}
                      >
                        Contrato y pagaré
                      </span>
                    </button>
                  </div>

                  <BottomSheet
                    open={dialogOpenContrato}
                    onOpenChange={setDialogOpenContrato}
                    isDesktop={isDesktop}
                    headerContent={
                      <div
                        className="flex rounded-2xl mx-auto font-semibold2"
                        style={{
                          backgroundColor: "#2C2447",
                          padding: "8px",
                          width: "200px",
                          margin: "0px",
                        }}
                      >
                        <button
                          onClick={() => handleTabClick("contrato")}
                          className={`flex-1 py-2 text-sm rounded-xl transition-all ${activeTab === "contrato"
                            ? "bg-purpleM text-white"
                            : "text-tgray"
                            }`}
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          Contrato
                        </button>
                        <button
                          onClick={() => handleTabClick("pagare")}
                          className={`flex-1 py-2 text-sm rounded-xl transition-all ${activeTab === "pagare"
                            ? "bg-purpleM text-white"
                            : "text-tgray"
                            }`}
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          Pagaré
                        </button>
                      </div>
                    }
                  >
                    <div className="space-y-3 w-full">
                      {activeTab === "contrato" ? (
                        <div
                          className="h-full rounded-t-3xl overflow-auto"
                          style={{
                            backgroundColor: "#2C2447",
                            color: "#FAFAFA",
                          }}
                        >
                          <ContractV3
                            basicInfo={creditUserStore}
                            userinfo={offerCreditStore}
                            creditUser={offerCreditStore}
                            firmaElectronica={
                              formDataOferta.tipoFirma === "electronica"
                                ? firmaElectronicaValue
                                : 0
                            }
                            dctoFirmaElectronica={
                              formDataOferta.tipoFirma === "electronica"
                                ? dctoFirmaElectronica
                                : 0
                            }
                            total={total}
                          />
                        </div>
                      ) : (
                        <div
                          className="h-full rounded-t-3xl overflow-auto"
                          style={{
                            backgroundColor: "#2C2447",
                            color: "#FAFAFA",
                          }}
                        >
                          <PromissoryV2
                            basicInfo={creditUserStore}
                            userinfo={offerCreditStore}
                          />
                        </div>
                      )}
                    </div>
                  </BottomSheet>

                  <BottomSheet
                    open={dialogOpenContratoFirma}
                    onOpenChange={setDialogOpenContratoFirma}
                    isDesktop={true}
                    headerContent={
                      <h2 className="font-semibold2">Firma manuscrita</h2>
                    }
                    footerContent={
                      <button
                        onClick={(e) => {
                          handleRequestPhysicalSignature();
                        }}
                        className="w-full bg-purple text-white py-3 gap-3 justify-center flex items-center"
                        style={{
                          borderRadius: "2.5rem",
                          height: "3.5rem",
                          fontSize: "20px",
                          backgroundColor:
                            isLoading || limitFirmaFisica > 2
                              ? "#2C2447"
                              : "#7E02FC",
                          cursor:
                            isLoading || limitFirmaFisica > 2
                              ? "not-allowed"
                              : "pointer",
                        }}
                      >
                        {isLoading ? (
                          <>
                            <div className="w-6 h-6 border-2 border-current border-t-transparent rounded-full animate-spin" />
                            Viajando...
                          </>
                        ) : (
                          <p style={{ fontSize: "1.1rem" }}>
                            {"Iniciar Proceso"}
                          </p>
                        )}
                      </button>
                    }
                  >
                    <div className="space-y-3 w-full">
                      <div
                        className="h-full rounded-t-3xl overflow-auto"
                        style={{
                          backgroundColor: "#2C2447",
                          color: "#FAFAFA",
                        }}
                      >
                        <ManualSignV3
                          isOpen={dialogOpenContratoFirma}
                          setOpen={setDialogOpenContratoFirma}
                        />
                      </div>
                    </div>
                  </BottomSheet>
                </div>
              </div>
              <div>
                <button
                  onClick={() => handleNext()}
                  type="button"
                  disabled={isLoadingButton}
                  style={{
                    height: "clamp(48px, 5vh, 56px)",
                    borderRadius: "2.5rem",
                    fontSize: "clamp(16px, 1.5vw, 20px)",
                    width: "196px",
                    marginRight: "clamp(35px, 8vh, 80px)",
                    marginBottom: "13px",
                    fontWeight: "500",
                    backgroundColor: isLoadingButton ? "#2C2447" : "#7E02FC",
                    cursor: "pointer",
                  }}
                  className={`flex items-center justify-center gap-3 px-4 py-3 transition-all duration-200 flex-1 font-medium text-base ${!isLoadingButton
                    ? "text-white hover:bg-purpleDark"
                    : "text-gray-500 cursor-not-allowed"
                    }`}
                >
                  {isLoadingButton ? (
                    <>
                      <div className="w-6 h-6 text-white border-2 border-current border-t-transparent rounded-full animate-spin" />
                      <span
                        className="text-white"
                        style={{ fontSize: "clamp(14px, 1.2vw, 18px)" }}
                      >
                        Viajando...
                      </span>
                    </>
                  ) : (
                    <>
                      <p
                        className="text-white"
                        style={{ fontSize: "clamp(16px, 1.5vw, 20px)" }}
                      >
                        Continuar
                      </p>
                      <ArrowRight className="w-6 h-6" />
                    </>
                  )}
                </button>
              </div>
            </div>
          );
        }
        break;

      default:
        return null;
    }
  };

  if (isApprovedCridit) {
    return (
      <Fragment>
        <div
          className="fixed inset-0 flex items-center justify-center min-h-screen w-full z-50"
          style={{
            color: "white",
            overflow: "hidden",
          }}
        >
          <canvas
            ref={starsRef}
            className="fixed inset-0 w-full h-full pointer-events-none"
          ></canvas>
          {/* Logo superior izquierda - solo desktop */}
          {isDesktop && (
            <div
              style={{
                backgroundColor: "#29214F",
                borderTopRightRadius: "50px",
                borderBottomRightRadius: "50px",
                width: "187px",
                height: "62px",
                position: "absolute",
                left: 0,
                top: 40,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                padding: "6px 20px 6px 0px",
              }}
            >
              <GalileIcon alt="Galilea" />
            </div>
          )}

          {/* Texto lateral izquierdo - solo desktop */}
          {isDesktop && (
            <div
              class="z-20 flex flex-col md:flex-row items-center justify-center gap-2.5 text-[#ffffff]/70 pointer-events-none select-none tracking-widest uppercase font-light text-[10px] text-center my-6 md:my-0 md:fixed md:w-auto md:left-[-290px] md:top-[50%] md:-translate-y-1/2 md:-rotate-90 md:origin-center">
              <div class="flex flex-row items-center justify-center gap-4 mr-2">
                <div class="flex items-center md:border-r border-[#ffffff]/30 pr-4 shrink-0 capitalize">
                  <img src="https://galilea.co/png/colombia-fintech.png" class="h-8 w-auto object-contain"
                    alt="colombia fintech" />
                </div>

                <div class="flex items-center md:border-r border-[#ffffff]/30 md:pr-4 shrink-0">
                  <img src="https://galilea.co/png/sic.png" class="h-6 w-auto object-contain brightness-0 invert opacity-90"
                    alt="Superintendencia de Industria y Comercio" />
                </div>
              </div>
              <span
                class="normal-case text-[11px] leading-tight tracking-normal text-[#ffffff]/70 max-w-[280px] md:max-w-[340px] font-semibold2">
                Galilea es una marca de GRUPO EMPRESARIAL ANAV S.A.S GEAA <br class="hidden md:inline" />registrada en
                Colombia con NIT: 901.582.748-5
              </span>

            </div>
          )}

          {/* Contenedor principal centrado */}
          {isDesktop ? (
            <div
              style={{
                width: "-webkit-fill-available",
                height: "-webkit-fill-available",
                backgroundColor: "#29214F",
                left: 390,
                top: "clamp(150px, 6vw, 200px)",
                position: "absolute",
                borderRadius: "30px",
                marginRight: "107px",
                marginBottom: "clamp(50px, 3vw, 80px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="flex flex-col items-center justify-center">
                {/* Componente de animación Rive */}
                <h1
                  className="font-bold2"
                  style={{
                    fontSize: "2rem",
                    width: "300px",
                    textAlign: "center",
                  }}
                >
                  ¡Luz Púrpura para Continuar!
                </h1>
                <AnimationComponent
                  animationUrl="/animations/checkanimation.riv"
                  width={"40vw"}
                  height={"40vh"}
                  isDesktop={isDesktop}
                  stateMachines={["chek-animation"]}
                />
                <p
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "200px",
                  }}
                >
                  <span>
                    ¡<span style={{ color: "#A68AFF" }}>Felicitaciones</span>!
                  </span>
                  <span
                    style={{
                      textAlign: "center",
                    }}
                  >
                    Tu solicitud fue aprobada y todos los sistemas están en
                    verde.
                  </span>
                </p>
              </div>
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center">
              {/* Componente de animación Rive */}
              <h1
                className="font-bold2"
                style={{
                  fontSize: "2rem",
                  width: "300px",
                  textAlign: "center",
                }}
              >
                ¡Luz Púrpura para Continuar!
              </h1>
              <AnimationComponent
                animationUrl="/animations/checkanimation.riv"
                width={"20rem"}
                height={"40rem"}
                heightContainer={"25rem"}
                isDesktop={isDesktop}
                stateMachines={["chek-animation"]}
              />
              <p
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "200px",
                }}
              >
                <span>
                  ¡<span style={{ color: "#A68AFF" }}>Felicitaciones</span>!
                </span>
                <span
                  style={{
                    textAlign: "center",
                  }}
                >
                  Tu solicitud fue aprobada y todos los sistemas están en verde.
                </span>
              </p>
            </div>
          )}
        </div>
      </Fragment>
    );
  }

  return (
    <div
      className={`px-4 ${!isDesktop && "mt-3"}`}
      style={{
        height: "-webkit-fill-available",
        width: "-webkit-fill-available",
        padding: isDesktop && "40px 0px",
      }}
    >
      {alertSession && (
        <>
          <InfoAlert
            isOpen={isOpenInfo}
            message={messsageAlert}
            isDesktop={isDesktop}
          ></InfoAlert>
          <ErrorAlert isOpen={isOpenError} message={messsageAlert}></ErrorAlert>
        </>
      )}

      <div
        className="flex flex-col justify-around"
        style={{
          height: isDesktop ? "-webkit-fill-available" : "90%",
        }}
      >
        <div
          className={`transition-all duration-300 ease-in-out overflow-y-auto ${isTransitioning
            ? "opacity-0 transform translate-x-4"
            : "opacity-100 transform translate-x-0"
            }`}
          style={{
            height: !isDesktop ? "82vh" : "-webkit-fill-available",
          }}
        >
          {!isDesktop && (
            <div className="text-center flex flex-col items-center px-2 mb-5">
              <div style={{ color: "#BEBCC2", fontSize: "14px" }}>
                Paso {currentStepGeneral} de {stepTitlesGeneral.length}
              </div>
              <div
                className="text-lg text-gray-800 max-w-50 sm:max-w-none"
                style={{
                  fontSize: 17,
                  marginBottom: "16px",
                  marginTop: "8px",
                }}
              >
                {stepTitlesGeneral && stepTitlesGeneral[currentStepGeneral - 1]}
              </div>
              <div
                className="text-xl font-bold2 text-gray-800 mt-3sm:max-w-none"
                style={{ width: "250px", lineHeight: "24px" }}
              >
                {creditUserStore?.firstname
                  ? `¡${creditUserStore.firstname}!`
                  : ""}{" "}
                Revisa las condiciones de tu crédito.
              </div>
            </div>
          )}

          <div
            className="w-full mx-auto"
            style={{
              height: isDesktop && "-webkit-fill-available",
            }}
          >
            {renderStep()}
          </div>
        </div>
      </div>
      {/* <DialogComponent
          open={openDialog}
          onOpenChange={setOpenDialog}
          title={titleDialog}
          description=
          acceptText=""
          onAccept={handleAccept}
          isDesktop={isDesktop}
        /> */}
      {openDialog && (
        <BottomSheet
          open={openDialog}
          onOpenChange={setOpenDialog}
          isDesktop={isDesktop}
          isFirmaManuscrita={true}
          headerContent={<h2 className="font-semibold2">{titleDialog}</h2>}
          footerContent={
            <button
              onClick={(e) => {
                handleAccept();
              }}
              className="w-full bg-purple text-white py-3 font-semibold2"
              style={{
                borderRadius: "2.5rem",
                height: "3.5rem",
                fontSize: "clamp(20px, 1.5vw, 25px)",
                cursor: "pointer",
              }}
            >
              Entendido
            </button>
          }
        >
          <div className="w-full">
            <div
              className="h-full flex flex-col items-center text-center font-semibold2"
              style={{
                color: "#FAFAFA",
                gap: "10px",
                fontSize: "20px",
                lineHeight: "27px",
              }}
            >
              <EmailOutlined style={{ width: "5rem", height: "5rem" }} />
              {descriptionDialog}
            </div>
          </div>
        </BottomSheet>
      )}
      {!isDesktop && (
        <div
          class="z-20 flex flex-col md:flex-row items-center justify-center gap-2.5 text-[#ffffff]/70 pointer-events-none select-none tracking-widest uppercase font-light text-[10px] text-center my-6 md:my-0 md:fixed md:w-auto md:left-[-290px] md:top-[50%] md:-translate-y-1/2 md:-rotate-90 md:origin-center">
          <div class="flex flex-row items-center justify-center gap-4 mr-2">
            <div class="flex items-center md:border-r border-[#ffffff]/30 pr-4 shrink-0 capitalize">
              <img src="https://galilea.co/png/colombia-fintech.png" class="h-8 w-auto object-contain"
                alt="colombia fintech" />
            </div>

            <div class="flex items-center md:border-r border-[#ffffff]/30 md:pr-4 shrink-0">
              <img src="https://galilea.co/png/sic.png" class="h-6 w-auto object-contain brightness-0 invert opacity-90"
                alt="Superintendencia de Industria y Comercio" />
            </div>
          </div>
          <span
            class="normal-case text-[11px] leading-tight tracking-normal text-[#ffffff]/70 max-w-[280px] md:max-w-[340px] font-semibold2">
            Galilea es una marca de GRUPO EMPRESARIAL ANAV S.A.S GEAA <br class="hidden md:inline" />registrada en
            Colombia con NIT: 901.582.748-5
          </span>
        </div>
      )}
    </div>
  );
};

export default RenovarDatosOfertaForm;
